import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';

import { AuthentificationService } from '../../providers/Global/authentification.service';
import { AdminService } from '../../providers/admin/admin.service';
import { DropzoneService } from '../../providers/Import/dropzone.service';

import { UserEditComponent } from '../../components/useredit/userEdit.component';
import { CategoryEditComponent } from '../../components/categoryedit/categoryEdit.component';
import { getColumnsWithIndex } from '../../ressources/constants/colHeaders';

interface Roles {
  id: number;
  name: string;
  description: string;
}
interface Categories {
  id: number;
  label: string;
  path?: string;
  import_sons: boolean;
  preselect_playlist: boolean;
  edit_winmedia: boolean;
}
interface Stations {
  id: number;
  label: string;
}

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, AfterViewInit {

  /* Global */
  permissions: Array<string> = [];

  @ViewChild('arlInput') arlInput;

  arlError = false;


  /* Users */
  @ViewChild('Paginator', {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  users: [] = [];
  usersMatTable;

  displayedColumns: string[] = ['uid', 'name', 'mail', 'team_name', 'effective_role', 'stations', 'categorie', 'hiddencolumns', 'edit'];

  roles: Roles[] = [];
  stations: Stations[] = [];
  categories: Categories[] = [];
  roleConfigs: any[] = [];

  /* Categories */
  allCategories: Categories[] = [];
  categoriesMatTable;
  catDisplayedColumns: string[] = ['label', 'path', 'import_sons', 'preselect_playlist', 'edit_winmedia', 'edit'];

  constructor(private authentificationService: AuthentificationService,
              private adminService: AdminService,
              private snackBar: MatSnackBar,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              private dropzoneService: DropzoneService,
              private dialog: MatDialog) {
    iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/edit.svg'));
    iconRegistry.addSvgIcon('add', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/add.svg'));
    this.permissions = this.authentificationService.permissionsSource.getValue();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.getArl();
    this.getDataDB();
    if (this.permissions.includes('user_config')) {
      this.getUsers();
    }
    if (this.permissions.includes('category_config') || this.permissions.includes('user_config')) {
      this.getAdminCategories();
    }
  }

  getArl() {
    this.arlError = false;
    this.adminService.getCurrentArl()
      .then(res => {
        this.arlInput.nativeElement.value = res.arl;
      })
      .catch(err => {
        console.log(err);
        this.arlError = true;
      });
  }

  updateARL(arlInput) {
    if (arlInput.value && arlInput.value.trim().length > 0) {
      this.adminService.editArl(arlInput.value.trim())
        .then(res => {
          console.log(res);
          this.snackBar.open(`ARL correctement mis à jour`);
        })
        .catch(err => {
          console.log(err);
          this.snackBar.open(`Erreur de mise à jour de l'ARL`);
        });
    }
  }

  getUsers() {
    this.adminService.getUsers()
      .then(res => {
        console.log(res);
        this.users = res;
        delete this.usersMatTable;
        this.usersMatTable = new MatTableDataSource<[]>(this.users);
        this.usersMatTable.paginator = this.paginator;
        this.paginator._intl.itemsPerPageLabel = 'Eléments affichés par page';
        this.paginator._intl.nextPageLabel = '';
        this.paginator._intl.previousPageLabel = '';
        this.paginator._intl.firstPageLabel = '';
        this.paginator._intl.lastPageLabel = '';
        this.usersMatTable.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'created': return new Date(item.created * 1000);
            case 'effective_role_id': return item.effective_role_id ? item.effective_role_id : 1000;
            default: return item[property];
          }
        };
        this.usersMatTable.sort = this.sort;
      })
      .catch(err => {
        console.log(err);
      });
  }

  getDataDB() {
    this.adminService.getRoles()
      .then(res => {
        // Filtrer le rôle "superadmin" et "partenaire" (id: 1 et 5)
        res = res.filter(r => (r.id !== 1 && r.id !== 5));
        this.roles = res;
        console.log('roles', this.roles);
      })
      .catch(() => {
        this.roles = [];
      });
    this.dropzoneService.getWinmediaData()
      .then(res => {
        this.stations = res.stations;
        console.log('stations', this.stations);
      })
      .catch(() => {
        this.stations = [];
      });
    this.dropzoneService.getCategories()
      .then(res => {
        this.categories = res;
        console.log('categories', this.categories);
      })
      .catch(() => {
        this.categories = [];
      });
    this.adminService.getRoleConfigs()
      .then(res => {
        this.roleConfigs = res;
      })
      .catch(() => {
        this.roleConfigs = [];
      });
  }

  doFilter(value: string) {
    this.usersMatTable.filter = value.trim().toLocaleLowerCase();
  }

  doCategoryFilter(value: string) {
    this.categoriesMatTable.filter = value.trim().toLocaleLowerCase();
  }

  /**
   * Convertit une liste d'IDs de stations en labels
   */
  getStationsLabels(stationsIds: string): string {
    if (!stationsIds || !this.stations || this.stations.length === 0) {
      return '';
    }
    const ids = stationsIds.split(',').map(id => Number(id.trim()));
    const labels = ids
      .map(id => {
        const station = this.stations.find(s => s.id === id);
        return station ? station.label : null;
      })
      .filter(label => label !== null);
    return labels.join(', ');
  }

  /**
   * Convertit un ID de catégorie en label
   */
  getCategorieLabel(categorieId: string): string {
    if (!categorieId || !this.categories || this.categories.length === 0) {
      return '';
    }
    const id = Number(categorieId);
    const categorie = this.categories.find(c => c.id === id);
    return categorie ? categorie.label : '';
  }

  /**
   * Convertit une liste d'IDs de colonnes en labels
   */
  getHiddencolumnsLabels(hiddencolumnsIds: string): string {
    if (!hiddencolumnsIds) {
      return '';
    }
    try {
      const ids = JSON.parse(hiddencolumnsIds);
      const labels = ids
      .map(id => {
        const column = getColumnsWithIndex().find(c => c.index === id);
        return column ? column.label : null;
      })
      .filter(label => label !== null);
    return labels.join(', ');
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  editUser(element) {
    const dialogRef = this.dialog.open(UserEditComponent, {
      width: '250px',
      height: '90%',
      data: {
        element: element,
        roles: this.roles,
        stations: this.stations,
        categories: this.categories,
        userExisting: !!element.rid,
        availableColumns: getColumnsWithIndex(),
        roleConfigs: this.roleConfigs
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      console.log(element);
      if (result && result.action && result.data) {
        switch (result.action) {
          case 'save':
            // Gestion de la création d'une nouvelle catégorie si nécessaire
            if (result.data.newCategorie) {
              this.adminService.addCategorie(result.data.newCatLabel, true, false)
                .then(resCat => {
                  console.log(resCat);
                  this.categories.push({
                    id: resCat.insertId,
                    label: result.data.newCatLabel,
                    import_sons: true,
                    preselect_playlist: false,
                    edit_winmedia: false
                  });
                  this.categories.sort((a, b) => a.label.localeCompare(b.label));
                  // Enregistrer les préférences avec la nouvelle catégorie
                  this.adminService.saveUserSettings(element.uid, result.data.role, resCat.insertId.toString(), result.data.stations, result.data.hiddencolumns, result.data.preferNickname, result.data.lowBitrateAllowed)
                    .then(res => {
                      console.log(res);
                      this.getUsers(); // Recharger la liste pour avoir les données à jour
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              // Enregistrer les préférences directement
              this.adminService.saveUserSettings(element.uid, result.data.role, result.data.categorie, result.data.stations, result.data.hiddencolumns, result.data.preferNickname, result.data.lowBitrateAllowed)
                .then(res => {
                  console.log(res);
                  this.getUsers(); // Recharger la liste pour avoir les données à jour
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            break;
          case 'remove':
            this.adminService.removeUserSettings(element.uid)
              .then(res => {
                console.log(res);
                this.getUsers(); // Recharger la liste pour avoir les données à jour
              })
              .catch((err) => {
                console.log(err);
              });
            break;
        }
      }
    });
  }

  getAdminCategories() {
    this.adminService.getAdminCategories()
      .then(res => {
        this.allCategories = res;
        this.categoriesMatTable = new MatTableDataSource<Categories>(this.allCategories);
      })
      .catch(err => {
        console.log(err);
      });
  }

  editCategory(element?: Categories) {
    const dialogRef = this.dialog.open(CategoryEditComponent, {
      width: '400px',
      data: { element: element || null, allCategories: this.allCategories }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.action || !result.data) return;

      switch (result.action) {
        case 'save':
          if (result.data.id) {
            // Mise à jour
            this.adminService.updateCategorie(result.data.id, result.data.label, result.data.importSons, result.data.preselectPlaylist, result.data.editWinmediaFlag)
              .then(() => this.getAdminCategories())
              .catch(err => {
                if (err?.status === 409) {
                  this.snackBar.open('Une catégorie avec ce nom existe déjà.', 'Fermer', { duration: 4000 });
                } else {
                  console.log(err);
                }
              });
          } else {
            // Création
            this.adminService.addCategorie(result.data.label, result.data.importSons, result.data.preselectPlaylist, result.data.editWinmediaFlag)
              .then(() => this.getAdminCategories())
              .catch(err => {
                if (err?.status === 409) {
                  this.snackBar.open('Une catégorie avec ce nom existe déjà.', 'Fermer', { duration: 4000 });
                } else {
                  console.log(err);
                }
              });
          }
          break;
        case 'delete':
          this.adminService.deleteCategorie(result.data.id)
            .then(() => this.getAdminCategories())
            .catch(err => console.log(err));
          break;
      }
    });
  }

}
